import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import ImprintPage from './pages/ImprintPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/impressum" element={<ImprintPage />} />
        <Route path="/agb" element={<TermsPage />} />
        <Route path="/datenschutz" element={<PrivacyPage />} />
      </Routes>
    </Router>
  );
}

export default App;
